import { FileText, Sparkles, Target, Eye, Download, LayoutGrid, SpellCheck, Linkedin } from "lucide-react";

const topFeatures = [
  { icon: FileText, label: "One-click Resume", animation: "animate-float-slow", position: "left-[5%] top-[15%]" },
  { icon: Sparkles, label: "AI Content", animation: "animate-float-medium", position: "left-[25%] top-[8%]" },
  { icon: Target, label: "ATS Scoring", animation: "animate-float-fast", position: "right-[25%] top-[10%]" },
  { icon: Eye, label: "Live Preview", animation: "animate-float-slow", position: "right-[5%] top-[18%]" },
];

const bottomFeatures = [
  { icon: Download, label: "PDF Export", animation: "animate-float-medium", position: "left-[8%] bottom-[15%]" },
  { icon: LayoutGrid, label: "50+ Templates", animation: "animate-float-fast", position: "left-[28%] bottom-[8%]" },
  { icon: SpellCheck, label: "Grammar Check", animation: "animate-float-slow", position: "right-[28%] bottom-[10%]" },
  { icon: Linkedin, label: "LinkedIn Sync", animation: "animate-float-medium", position: "right-[8%] bottom-[18%]" },
];

const FeatureBubbles = () => {
  return (
    <>
      {/* Top floating bubbles */}
      {topFeatures.map((feature, index) => (
        <div
          key={`top-${index}`}
          className={`absolute hidden md:flex items-center gap-2 bg-background/25 backdrop-blur-md border border-primary-foreground/20 rounded-full px-4 py-2 text-primary-foreground shadow-xl ${feature.animation} ${feature.position} z-20`}
          style={{ animationDelay: `${index * 0.2}s` }}
        >
          <feature.icon className="w-4 h-4" />
          <span className="text-sm font-medium whitespace-nowrap">{feature.label}</span>
        </div>
      ))}

      {/* Bottom floating bubbles */}
      {bottomFeatures.map((feature, index) => (
        <div
          key={`bottom-${index}`}
          className={`absolute hidden md:flex items-center gap-2 bg-background/25 backdrop-blur-md border border-primary-foreground/20 rounded-full px-4 py-2 text-primary-foreground shadow-xl ${feature.animation} ${feature.position} z-20`}
          style={{ animationDelay: `${index * 0.3 + 0.5}s` }}
        >
          <feature.icon className="w-4 h-4" />
          <span className="text-sm font-medium whitespace-nowrap">{feature.label}</span>
        </div>
      ))}

      {/* Mobile: Compact inline bubbles */}
      <div className="flex md:hidden flex-wrap justify-center gap-2 max-w-sm mx-auto mt-6 px-2">
        {[...topFeatures, ...bottomFeatures].map((feature, index) => (
          <div
            key={`mobile-${index}`}
            className="flex items-center gap-1.5 bg-background/20 backdrop-blur-md border border-primary-foreground/20 rounded-full px-3 py-1.5 text-primary-foreground shadow-lg animate-fade-in"
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <feature.icon className="w-3 h-3" />
            <span className="text-xs font-medium whitespace-nowrap">{feature.label}</span>
          </div>
        ))}
      </div>
    </>
  );
};

export default FeatureBubbles;
